import { render } from "./LoadingUnloadingRegister.vue?vue&type=template&id=0d5c3898"
import script from "./LoadingUnloadingRegister.vue?vue&type=script&lang=js"
export * from "./LoadingUnloadingRegister.vue?vue&type=script&lang=js"

import "./LoadingUnloadingRegister.vue?vue&type=style&index=0&id=0d5c3898&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__